(function () {
  function initSection(sectionRoot) {
    if (!sectionRoot) return;

    const swiperEl = sectionRoot.querySelector('[data-rs50-swiper]');
    const paginationEl = sectionRoot.querySelector('[data-rs50-pagination]');
    if (!swiperEl || !paginationEl) return;

    // Evite bugs si 1 seul slide
    const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

    // Stocker l’instance sur le DOM pour éviter double init
    if (sectionRoot.__rs50Swiper) {
      sectionRoot.__rs50Swiper.destroy(true, true);
      sectionRoot.__rs50Swiper = null;
    }

    const autoplayEnabled = sectionRoot.dataset.autoplay === 'true';
    const loopEnabled = sectionRoot.dataset.loop === 'true';
    const delay = parseInt(sectionRoot.dataset.delay || '3500', 10);
    const speed = parseInt(sectionRoot.dataset.speed || '500', 10);

    sectionRoot.__rs50Swiper = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed,
      loop: loopEnabled && slideCount > 1,
      autoplay: (autoplayEnabled && slideCount > 1) ? {
        delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      } : false,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      observer: true,
      observeParents: true
    });
  }

  function initAll() {
    document.querySelectorAll('[data-rs50-root]').forEach(initSection);
  }

  // Chargement normal
  document.addEventListener('DOMContentLoaded', () => {
    // si Swiper pas prêt, on retente vite
    const wait = () => (window.Swiper ? initAll() : setTimeout(wait, 50));
    wait();
  });

  // Theme editor
  document.addEventListener('shopify:section:load', (e) => {
    const root = document.querySelector(`#rs50-${e.detail.sectionId}[data-rs50-root]`);
    const wait = () => (window.Swiper ? initSection(root) : setTimeout(wait, 50));
    wait();
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const root = document.querySelector(`#rs50-${e.detail.sectionId}[data-rs50-root]`);
    if (root && root.__rs50Swiper) {
      root.__rs50Swiper.destroy(true, true);
      root.__rs50Swiper = null;
    }
  });
})();